import React from 'react'

const PageContent = ({children}: {children: React.ReactNode}) => {
    return (
        <div className="flex flex-1 rounded-t-[2.5rem] bg-cream-10 pb-20">
            {children}
        </div>
    )
}

export default PageContent
